<template>
  <div class="admin-tenantlist">
    <admin-template
      :endpointUrl="endpointUrl"
      :title="title"
      :tableSort="{prop: 'name', order: 'descending'}"
      :visibleTenantsSelect="false"
    >
      <template slot="table-columns">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <table class="detail" v-if="scope.row.assigned.length!==0">
              <thead>
                <th class="enabled">有効</th>
                <th class="name">認証連携アプリケーション名</th>
                <th class="period">有効期間</th>
                <th class="command">操作</th>
              </thead>
              <tbody>
                <tr v-for="item in scope.row.assigned" v-bind:key="item.name">
                  <td class="enabled">
                    <i v-if="item.enabled" class="fa fa-lg fa-check fg-success"></i>
                    <i v-else class="fa fa-lg fa-minus-square fg-danger"></i>
                  </td>
                  <td class="name">{{ item.name}}</td>
                  <td class="period">{{ item.start_date}} - {{item.end_date}}</td>
                  <td class="command">
                    <el-button
                      icon="el-icon-edit"
                      size="small"
                      @click="onClickApplicationConfig(item)"
                    >設定</el-button>
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      size="small"
                      @click="onClickApplicationWithdraw(item)"
                    >解除</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </el-table-column>
        <el-table-column type="selection" width="55" :selectable="selectableRow"></el-table-column>
        <el-table-column prop="name" label="テナント名" sortable>
          <template slot-scope="scope">{{ scope.row.name}}</template>
        </el-table-column>
        <el-table-column prop="mfa_required" label="MFA必須" width="100" sortable>
          <template slot-scope="scope">
            <i v-if="scope.row.mfa_required" class="el-icon-check" style="color: green;"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="small"
              @click="onClickEditButton(scope.row.uuid)"
            >テナント名の変更</el-button>
            <el-button
              size="small"
              @click="onClickAssignApplication(scope.row.uuid, scope.row.assigned)"
            >
              <i class="fab fa-openid"></i>
              認証連携アプリケーションの割当
            </el-button>
          </template>
        </el-table-column>
      </template>
    </admin-template>

    <admin-dialog
      :endpointUrl="endpointUrl"
      :endpointBulkDeleteUrl="endpointBulkDeleteUrl"
      :title="title"
      :form="form"
      :selection="selection"
    >
      <template slot="dialogFormItem">
        <el-form-item label="テナント名" prop="name">
          <el-input v-model="form.data.name" auto-complete="off" :autofocus="true"></el-input>
        </el-form-item>
        <el-form-item label="多要素認証を必須にする" prop="mfa_required">
          <el-switch v-model="form.data.mfa_required"></el-switch>
        </el-form-item>
      </template>
    </admin-dialog>

    <div class="application-assign">
      <el-dialog
        class="application-assign-dialog"
        title="認証連携アプリケーションの割当"
        :visible.sync="appAssignDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <el-select v-model="appAssignDialog.form.app_id">
          <el-option
            v-for="app in appAssignDialog.no_assigned_apps"
            :key="app.id"
            :label="app.name"
            :value="app.id"
          ></el-option>
        </el-select>
        <el-alert
          v-if="appAssignDialog.isAlert"
          :title="appAssignDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleApplicationAssign"
            :loading="appAssignDialog.loading"
          >OK</el-button>
          <el-button @click="handleApplicationAssignCancel">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="application-withdraw">
      <el-dialog
        class="message-box"
        title="認証連携アプリケーションの解除確認"
        :visible.sync="appWithDrawDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <span>{{ appWithDrawDialog.form.name}}の割当を解除してもよいですか？</span>
        <span slot="footer" class="dialog-footer">
          <el-alert
            v-if="appWithDrawDialog.isAlert"
            :title="appWithDrawDialog.errorMessage"
            type="error"
            show-icon
            :closable="false"
          ></el-alert>
          <el-button
            type="danger"
            @click="handleApplicationWithdraw"
            :loading="appWithDrawDialog.loading"
          >はい</el-button>
          <el-button @click="appWithDrawDialog.visible = false">いいえ</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="application-config">
      <el-dialog
        class="application-dialog"
        :title="appConfigDialog.title"
        :visible.sync="appConfigDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <el-form :model="appConfigDialog.form" label-width="300px">
          <el-form-item label="有効">
            <el-checkbox v-model="appConfigDialog.form.enabled"></el-checkbox>
          </el-form-item>
          <el-form-item label="有効期間" prop="valid_period">
            <el-date-picker
              v-model="appConfigDialog.form.valid_period"
              type="daterange"
              align="right"
              start-placeholder="開始日"
              end-placeholder="終了日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            v-for="c in appConfigDialog.form.config"
            :label="c.title"
            v-bind:key="c.key"
          >
            <el-input-number v-if="c.type === 'integer'" placeholder v-model="c.value"></el-input-number>
            <el-switch v-else-if="c.type === 'boolean'" placeholder v-model="c.value"></el-switch>
            <el-input v-else v-model="c.value"></el-input>
          </el-form-item>
        </el-form>
        <el-alert
          v-if="appConfigDialog.isAlert"
          :title="appConfigDialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="handleApplicationConfig"
            :loading="appConfigDialog.loading"
          >OK</el-button>
          <el-button @click="appConfigDialog.visible=false">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AdminTemplate from "@/components/admin/Template";
import AdminDialog from "@/components/admin/Dialog";
import { AdminEventBus } from "@/components/admin/EventBus";
import axios from "axios";
import { executeRequest } from "@/components/requests";

export default {
  components: {
    AdminTemplate,
    AdminDialog
  },

  data() {
    const endpointUrl = "/api/accounts/admin/tenants-detail/";
    const endpointBulkDeleteUrl = "/api/accounts/admin/tenants-bulk/";
    const applicationListUrl = "/api/consumers/simple/";
    const applicationDetailUrl = "/api/consumers/detail/";
    const applicationConfigUrl = "/api/consumers/tenant-config/";
    const title = "テナント管理";
    const initialFormData = {
      uuid: 0,
      name: "",
      assigned: [],
      mfa_required: false
    };
    const rule = {
      name: [
        {
          required: true,
          message: "テナント名を入力してください",
          trigger: "blur"
        }
      ]
    };

    return {
      title,
      endpointUrl,
      endpointBulkDeleteUrl,
      applicationListUrl,
      applicationDetailUrl,
      applicationConfigUrl,
      form: {
        ref: "adminTenantForm",
        labelWidth: "150px",
        data: Object.assign({}, initialFormData),
        rules: {
          create: rule,
          update: rule
        }
      },
      groupEndpointUrl: "/api/admin/usergroups/groups/",
      selection: [],

      appAssignDialog: {
        visible: false,
        form: {},
        no_assigned_apps: [],
        loading: false,
        errorMessage: "",
        isAlert: false
      },

      appWithDrawDialog: {
        visible: false,
        form: {},
        loading: false,
        errorMessage: "",
        isAlert: false
      },

      appConfigDialog: {
        visible: false,
        form: {},
        title: "",
        loading: false,
        errorMessage: "",
        isAlert: false
      }
    };
  },
  created() {
    AdminEventBus.$on("init-form", () => {
      this.initForm();
    });
  },
  methods: {
    initForm() {
      this.form.data = Object.assign({}, this.initialFormData);
    },
    onClickEditButton(uuid) {
      axios.get(`${this.endpointUrl}${uuid}/`).then(response => {
        this.form.data = response.data;
        AdminEventBus.$emit("click-edit");
      });
    },
    onClickAssignApplication(tenant_uuid, assigned) {
      axios.get(this.applicationListUrl).then(response => {
        const assigned_apps = assigned.map(item => item.app_id);
        const no_assigned_apps = response.data.filter(
          item => assigned_apps.indexOf(item.id) === -1
        );
        this.appAssignDialog.title = "認証連携アプリケーションの割当";
        this.appAssignDialog.no_assigned_apps = no_assigned_apps;
        this.appAssignDialog.target = undefined;
        this.appAssignDialog.visible = true;
        this.appAssignDialog.form = Object.assign(
          {},
          this.appAssignDialog.form,
          { app_id: undefined, tenant_uuid: tenant_uuid }
        );
      });
    },
    onClickApplicationConfig(target) {
      axios
        .get(`${this.applicationConfigUrl}${target.uuid}/`)
        .then(response => {
          this.appConfigDialog.title = `${target.name}の設定`;
          this.appConfigDialog.form = response.data;
          this.appConfigDialog.form = Object.assign(
            {},
            this.appConfigDialog.form,
            { configJson: {} }
          );
          this.appConfigDialog.visible = true;
        });
    },
    onClickApplicationWithdraw(item) {
      this.appWithDrawDialog.form = item;
      this.appWithDrawDialog.visible = true;
    },
    selectableRow(row, index) {
      if (row.name === "admin") {
        return false;
      } else if (row.username === this.$store.getters.loginStatus.username) {
        return false;
      }
      return true;
    },
    executeApplicationRequest(request, dialog) {
      executeRequest(request, dialog)
        .then(response => {
          AdminEventBus.$emit("refresh");
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleApplicationAssign() {
      this.executeApplicationRequest(
        {
          method: "post",
          url: this.applicationConfigUrl,
          data: this.appAssignDialog.form
        },
        this.appAssignDialog
      );
    },
    handleApplicationAssignCancel() {
      this.appAssignDialog.visible = false;
    },
    handleApplicationWithdraw() {
      this.executeApplicationRequest(
        {
          method: "delete",
          url: `${this.applicationConfigUrl}${
            this.appWithDrawDialog.form.uuid
          }/`
        },
        this.appWithDrawDialog
      );
    },
    handleApplicationConfig() {
      const config = this.appConfigDialog.form.config.reduce(function(
        acc,
        cur
      ) {
        acc[cur.key] = cur.value;
        return acc;
      },
      {});
      this.appConfigDialog.form.configJson = JSON.stringify(config);

      this.executeApplicationRequest(
        {
          method: "put",
          url: `${this.applicationConfigUrl}${this.appConfigDialog.form.uuid}/`,
          data: this.appConfigDialog.form
        },
        this.appConfigDialog
      );
    }
  }
};
</script>

<style scoped>
.application-assign-dialog >>> .el-dialog {
  width: 500px;
}

.application-assign-dialog >>> .el-dialog__body {
  padding: 10px 20px;
}

.application-assign-dialog >>> .el-select {
  width: 100%;
}
.admin-tenantlist >>> .el-table__expanded-cell {
  padding: 0;
}

.admin-tenantlist >>> .el-table__row.expanded td {
  border-bottom: 0;
}

table.detail {
  margin: 8px 110px;
  border: 1px solid #ccc !important;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
}
.detail th,
.detail td {
  padding: 4px 16px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

.detail td:last-child,
.detail th:last-child {
  border-right: 0;
}
.detail thead th {
  background-color: #eee;
  font-weight: normal;
}
.detail tbody tr:last-child th,
.detail tbody tr:last-child td {
  border-bottom: none;
}

.detail .enabled,
.detail .period,
.detail .command {
  text-align: center;
}

.detail .enabled {
  width: 20px;
}
.detail .name {
  width: 200px;
}

.detail .period {
  width: 200px;
}

.detail .command {
  width: 200px;
}
</style>
